import { axiosInstance } from './axios-instance';
import * as endpoints from "../constants/api-constants";


class ConsultingService {
    static saveConsulting(payload) {
        return axiosInstance.post(endpoints.commentsByTopic, payload).then(resp => resp.data)
    }
    static getListComments(consultingType, consultingTopic, size, page) {
        return axiosInstance.get(endpoints.commentsByTopic + '?consultingType=' + consultingType + '&consultingTopic=' + consultingTopic + '&size=' + size + '&page=' + page + '&country=' + process.env.COUNTRY_CODE).then(resp => resp.data)
    }
    static getListCommentsAuth(consultingType, consultingTopic, size, page, config) {
        return axiosInstance.get(endpoints.commentsByTopic + '?consultingType=' + consultingType + '&consultingTopic=' + consultingTopic + '&size=' + size + '&page=' + page + '&country=' + process.env.COUNTRY_CODE, config).then(resp => resp.data)
    }
    static setLikeAlsoConsulted(payload) {
        return axiosInstance.post(endpoints.likesOrDislike, payload)
    }
    static setLikeAlsoConsultedAuth(payload, config) {
        return axiosInstance.post(endpoints.likesOrDislike, payload, config)
    }

    // static qualifyProduct(payload, config){
    //     return axios.post(endpoints.qualifyProduct, payload, config).then(res => res.data)
    // }

    // static commentProduct(payload, config){
    //     return axios.post(endpoints.commentProduct, payload, config).then(res => res.data)
    // }
}

export default ConsultingService;